export default __webpack_public_path__ + "static/media/banner.2bdb28f3.png";